<div class="flex flex-col w-full relative">
    <label *ngIf="label" class="text-[11px] font-black text-text-muted uppercase tracking-[0.25em] ml-1">
        {{ label }}
    </label>

    <!-- LEFT ALIGNED OTP Inputs -->
    <div class="flex" [ngClass]="distributeClass" (paste)="onPaste($event)">
        <div *ngFor="let val of otpValues; let i = index; trackBy: trackByFn" class="relative group">
            <input #otpInput [id]="'otp-' + i" type="tel" inputmode="numeric" maxlength="1" [value]="val" [disabled]="disabled"
                autocomplete="off"
                (keydown)="onKeyDown($event, i)" (focus)="onFocus($event)"
                class="bg-surface border-2 border-surface-muted rounded-2xl text-center font-black transition-all duration-300 outline-none
               hover:border-slate-300 focus:border-primary focus:ring-4 focus:ring-primary/10 placeholder:text-text-muted
               disabled:bg-surface-muted disabled:cursor-not-allowed group-focus-within:shadow-xl text-foreground"
                [ngClass]="sizeClasses"
                [class.border-red-400]="error" [class.focus:border-red-400]="error"
                [class.focus:ring-red-400/10]="error" />

            <!-- Specialized Focus Underline -->
            <div
                class="absolute bottom-1 left-2 right-2 h-1 bg-primary scale-x-0 group-focus-within:scale-x-100 transition-transform duration-500 rounded-full opacity-40">
            </div>
        </div>
    </div>

    <!-- Left Aligned Error Message -->
    <div *ngIf="error"
        class="absolute -bottom-5 right-5 text-[9px] font-bold text-red-500 ml-1 mt-0.5 animate-fade-in flex items-center gap-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        {{ error }}
    </div>
</div>